const Resources = {

    table_headers: [
        { 
          text: 'Description',
          align: 'start',
          value: 'description',
          type:  'link'
        },
        { 
          text: 'Room',
          value: 'room'
        },
        {   
            text: 'Requestor name',
            value: 'requestor_name'
        },
        {   
            text: 'Requestor email',
            value: 'requestor_email'
        },
        {   
            text: 'Requestor phone',
            value: 'requestor_phone'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Service Requests',
            href:   '/assignment-service-request',
            arrow:  "",
        },
    ],

}

export default Resources;